<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height"
			@show="modal_onshow" show-footer @hide="modal_onhide" destroy-on-close>
			<template #default>
				<el-divider content-position="left">拆出数量</el-divider>
				<el-input-number size="mini" v-model="splitnum" :min="1" :max="maxnum"></el-input-number>
				<el-divider content-position="left">目标仓库</el-divider>
				<vxe-grid ref="splitoption" v-if="list_gridOptions" v-bind="list_gridOptions"
					@toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
			</template>
			<template #footer>
				<vxe-button status="primary" content="确认" @click="submit"></vxe-button>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	export default {
		mixins: [listMixins, modalMixins],
		props: {
			data: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				modal_model: false,
				modal_title: '拆单配置',
				modal_width: 600,
				modal_height: 700,
				maxnum: 0,
				splitnum: 0
				// list_footerField:[
				// 	{field:'needamount',toFixed:2}
				// ]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			modal_init() {
				this.maxnum = this.data.tp_item_size
				this.splitnum = this.data.tp_item_size
			},
			list_beforeCreateGrid(gridOptions) {
				gridOptions.height = 400
				gridOptions.treeConfig = null
				gridOptions.toolbarConfig = false
				gridOptions.radioConfig = {
					strict: false,
					trigger: 'row'
				}
				gridOptions.columns = [{
						type: "radio",
						field: '',
						title: '#',
						width: 50,
						align: 'center'
					},
					{
						field: 'storage_name',
						title: '仓库',
					},
					{
						field: 'availableSize',
						title: '可用',
					}
				]
				gridOptions.formConfig = false
			},
			list() {
				return new Promise((resolve) => {
					//console.log(this.data, 123123)
					this.$api.preoutorder.wlnqueryStorageDetail({
						sys_item_id: this.data.sys_item_id,
						sys_sku_id: this.data.sys_sku_id
					}).then((res) => {
						
						resolve({
							list: res.filter((item)=>{
								return item.storageID!=this.data.storage_uid
							})
						})
					})
				})
			},
			detail() {

			},
			submit() {
				let warehouse = this.$refs.splitoption.getRadioRecord()
				if (this.num > this.data.tp_item_size) {
					this.$message.error('拆出数量不能大于原数量')
					return
				}
				if (!warehouse) {
					this.$message.error('请选择仓库')
					return
				}
				this.$emit('submit', {
					data:this.data,
					config: {
						splitnum: this.splitnum,
						warehouse: warehouse
					}
				})
				this.modal_cancel()
			},
			reset() {
				//this.init()
			}
		},
		components: {

		}
	}
</script>